import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"
import { usDigits, formatUsDigits } from "../lib/us_phone"

// Sits on a phone <input> (Kloepfer K8-8, 2026-10-08): the number takes the
// usual (xxx) xxx-xxxx shape as it's typed, and stays that way when saved.
// The page adds this controller only for US companies (us_phone_attrs).
//
//   <input type="text" data-controller="phone-format"
//          data-action="input->phone-format#format blur->phone-format#done">
export default class extends Controller {
  connect() {
    this.lastDigits = usDigits(this.element.value) ?? ""
    this.format()
  }

  format(event) {
    const input = this.element
    const raw = input.value
    let digits = usDigits(raw)
    if (digits === null) return // not a US number: leave it as typed

    // Backspace over a ")" or "-" would put it straight back: drop the digit before it instead.
    if (event?.inputType === "deleteContentBackward" && digits === this.lastDigits && digits.length) digits = digits.slice(0, -1)
    this.lastDigits = digits

    const formatted = formatUsDigits(digits)
    if (formatted === raw) return
    // Keep the caret after the same number of digits it was after before.
    const caret = input.selectionStart ?? raw.length
    const digitsBefore = raw.slice(0, caret).replace(/\D/g, "").length
    input.value = formatted
    let position = formatted.length
    if (caret < raw.length) {
      let seen = 0
      position = 0
      while (position < formatted.length && seen < digitsBefore) {
        if (/\d/.test(formatted[position])) seen++
        position++
      }
    }
    try { input.setSelectionRange(position, position) } catch (_) { /* not a text input */ }
  }

  done() {
    if (this.tracked || (this.lastDigits || "").length !== 10) return
    this.tracked = true
    track("Phone Number Formatted", { field: this.element.name || this.element.dataset.field || this.element.getAttribute("aria-label") || "phone" })
  }
}
